import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
@Directive({
    selector: '[ngxDecimalNumberES]',
    standalone: false
})
export class NgxDecimalNumberEsDirective implements OnInit {
  @Input() maxDecimalRange: number;
  @Input() allowNegativeNumber: boolean;
  private readonly maxDecimalDefault = 20;
  private regexString = '';
  private regex: RegExp;

  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Del',
    'Delete',
  ];
  constructor(private el: ElementRef) {}

  ngOnInit() {
    const decimalRange = this.maxDecimalRange || this.maxDecimalDefault;
    const addNegativeKey =
      this.allowNegativeNumber !== undefined ? this.allowNegativeNumber : true;
    this.regexString = '^\\d*\\,?\\d{0,' + decimalRange + '}$';
    this.regex = new RegExp(this.regexString, 'g');

    if (addNegativeKey) {
      this.specialKeys.push('-');
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = this.el.nativeElement.value;

    const position = this.el.nativeElement.selectionStart;
    const next: string = [
      current.slice(0, position),
      event.key == 'Decimal' ? ',' : event.key,
      current.slice(position),
    ].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
